import React, { useContext, useState } from "react";

import { AnimatedCarousel as Value } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { notEmptyOrBlank } from "@thelabnyc/thelabui/src/utils/functional";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ReactivatedContext as Context } from "../../context";
import { Themed } from "../../styles/themes";
import { MarqueeBlock } from "../MarqueeBlock";

import styles from "./AnimatedCarousel.module.scss";

type SlideProps = NonNullable<Value["slides"]>[number]["value"];

const ImageSlide = ({ image }: SlideProps) => {
    if (!image) return <></>;

    return (
        <div className={styles.slide}>
            <ImageChooserBlock
                value={image}
                sizes={styles.sizes}
                imageAttrs={{ loading: "eager", className: styles.image }}
                attrs={{ className: styles.picture }}
            />
        </div>
    );
};

export const AnimatedCarousel = ({
    value: { slides, theme, block_label },
}: {
    value: Value;
}) => {
    const { DESIGN_VERSION } = useContext(Context);
    const [isPaused, setIsPaused] = useState(false);
    if (!slides) return <></>;

    const duration = slides.reduce(
        (accumulator, current) =>
            accumulator + (current.value.image?.width ?? 0),
        0,
    );

    return (
        <Themed theme={DESIGN_VERSION === "v2026" ? theme : null}>
            <MarqueeBlock
                durationInSeconds={duration / 150}
                onPauseChange={setIsPaused}
                ariaLabel={block_label ?? undefined}
                attrs={{
                    className: concatClassNames([
                        isPaused ? styles.carousel : styles.carouselWithMask,
                        "animatedCarouselStatic",
                    ]),
                }}
            >
                {slides.filter(notEmptyOrBlank).map((slide) => (
                    <ImageSlide key={slide.id} {...slide.value} />
                ))}
            </MarqueeBlock>
        </Themed>
    );
};
